<main>
  <header class="masthead">
    <div>
      <p class="eyebrow">FEDERAL RESERVE × S&amp;P 500</p>
      <h1>Policy / Market</h1>
      <p class="lede">Weekly market ranges, placed in the rhythm of FOMC decisions.</p>
    </div>
    <a href="https://www.federalreserve.gov/monetarypolicy/fomccalendars.htm" target="_blank" rel="noreferrer">
      Federal Reserve source ↗
    </a>
  </header>

  @if (dashboard$ | async; as dashboard) {
    @if (dashboard.years.length) {
      <section class="chart-card">
        <div class="section-heading">
          <div class="chart-description">
            <p class="eyebrow">FISCAL LOG SCALE · 1–10</p>
            <h2>Federal fiscal year · Oct–Sep</h2>
          </div>
          <div class="legend d-flex flex-row flex-wrap justify-content-between align-items-center gap-2">
            <div class="d-flex flex-row flex-wrap align-items-center legend-column">
              @for (feed of seriesManager.definitions; track feed.key) {
                <button type="button" [class.active]="seriesManager.isVisible(feed.key)"
                  [attr.aria-pressed]="seriesManager.isVisible(feed.key)"
                  [attr.title]="feed.description"
                  (click)="seriesManager.toggle(feed.key)">
                  <b class="series-key" [style.background]="feed.color"></b> {{ feed.label }}
                </button>
              }
            </div>

            <div class="d-flex flex-row flex-wrap align-items-center legend-column banks-column">
              <button type="button" class="banks-master-toggle"
                [class.active]="seriesManager.allBanksVisible()"
                [attr.aria-pressed]="seriesManager.allBanksVisible()"
                [attr.title]="seriesManager.allBanksVisible() ? 'Hide all central banks' : 'Show all central banks'"
                (click)="seriesManager.toggleAllBanks()">
                <b class="banks-toggle-key"></b>
                Banks {{ seriesManager.allBanksVisible() ? 'on' : 'off' }}
              </button>
              @for (bank of seriesManager.toggleableBanks(); track bank.key) {
                <button type="button" [class.active]="seriesManager.isBankVisible(bank.key)"
                  [attr.aria-pressed]="seriesManager.isBankVisible(bank.key)"
                  [attr.title]="bank.description"
                  (click)="seriesManager.toggleBank(bank.key)">
                  <b class="series-key" [style.background]="bank.color"></b> {{ bank.label }}
                </button>
              }
            </div>
          </div>
        </div>

        <div class="line-chart">
          @for (year of dashboard.years; track year.year) {
            <app-fiscal-row>
              <app-fiscal-row-header row-header [year]="year" />
              <app-fiscal-month-events row-events [year]="year" />
              <app-fiscal-line-chart row-chart [year]="year" />
              <app-fiscal-rate-table row-table [year]="year" />
            </app-fiscal-row>
          }
        </div>
      </section>
    } @else {
      <section class="empty">
        <p class="eyebrow">NO DATA RETURNED</p>
        <h2>The function returned an empty dataset.</h2>
      </section>
    }
  } @else {
    <section class="empty"><h2>Loading the policy timeline…</h2></section>
  }

  <footer>
    <p><strong>SPY</strong>, <strong>GLD</strong>, <strong>USO</strong>, the <strong>dollar index</strong>, and <strong>US unemployment</strong> are placed 1–10 per federal fiscal year, each against the band of its own and the previous year.</p>
  </footer>
</main>
